module.exports = __webpack_public_path__ + "static/media/hibiki-otsuki-icon.97ee611d.jpg";